<vb-confirmation-dialog [title]="'Media_Videos_Playback_DownloadError' | translate" [message]="'Media_Videos_Playback_DownloadErrorMsg' | translate" [actionText]="'Ok' | translate">
</vb-confirmation-dialog>

<span *ngIf="desktopUserAgent">
	<a *ngIf="videoAvailableForDownload || videoNotAvailableForDownload" [ngClass]="styles.download" [attr.aria-label]="'Media_Videos_Playback_Download' | translate " download [href]="video.downloadUrl" (click)="downloadVideo()" [disabled]="videoNotAvailableForDownload" vbUiBtnPrimaryNgx [tooltip]="(videoAvailableForDownload ? 'Media_Videos_Playback_DownloadVideo' : 'Media_Videos_Playback_NoFormatsAvailable') | translate" placement="bottom">
		<span class="glyphicons download_alt"></span>
	</a>

	<a *ngIf="videoNotPreparedForDownload" [attr.aria-label]="'Media_Videos_Playback_Download' | translate " [ngClass]="styles.download" downloads role="button" (click)="transcodeVideoForDownload()" vbUiBtnPrimaryNgx>
		<span class="glyphicons download_alt"></span>
	</a>

	<span *ngIf="videoPreparingForDownload" [ngClass]="styles.spinner" aria-disabled="true" [attr.aria-label]="'Processing' | translate " [tooltip]="'Media_Videos_Playback_PreparingForDownload' | translate" placement="bottom">
		<vb-loading-spinner class="margin-right-0"></vb-loading-spinner>
		{{ 'Processing' | translate }}
	</span>
</span>